var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.product)?_c('PageProductDetail',{attrs:{"product":_vm.product,"configurator-data":_vm.configuratorData,"menu-item":_vm.menuItem,"route-configuration":_vm.routeConfiguration}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }